import { GeckoToastService } from '../ui';

export const handleAPIError = (err, fallback = 'Something went wrong') => {
  const isWebSafe = err.safe?.length;
  new GeckoToastService().error(isWebSafe ? err.safe.join('\n') : fallback);
};
